import { defineAction } from '~/prix'
import inventoryDeleteAction from './inventoryDelete.action.json' with { type: 'json' }
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'

const inventoryDeleteDefinition = defineAction({
  ...inventoryDeleteAction,

  input: z.object({
    id: z.string().uuid(),
    updatedAt: dateOrIsoString().nullish(),
  }),
  output: z.object({}),
})

export default inventoryDeleteDefinition
